// the known groups a user may belong to
const ACCOUNT_MANAGERS = 'Account Managers';
const CLAIMS_TEAM = 'Claims team';
const CONTENT_TEAM = 'Content team';
const HR_TEAM = 'Apryl HR team';
const MX_TEAM = 'Care team';
const CANADA_TEAM = 'Canada Care Team';
const AI_TRAINING_TEAM = 'AI Training team';
export const CRAWFORD_TEAM = 'Crawford team';

// pseudo-groups that make for nicer PERMISSIONS
const ALL = '__all__';
const SUPERUSERS = '__superusers__';

// a dict where each key is a high-level module of the admin and each value is
// one of the following:
//
// - the name of the user group that can read and write the module
// - a list of the names of the user groups that can read and write the module
// - a {read, write} object where each value is one of the above
const PERMISSIONS = {
  accounts: { read: ALL, write: ACCOUNT_MANAGERS },
  admins: HR_TEAM,
  annexes: { read: ALL, write: SUPERUSERS },
  care: [CANADA_TEAM, MX_TEAM],
  claims: CLAIMS_TEAM,
  crawford: CRAWFORD_TEAM,
  invoice_training: AI_TRAINING_TEAM,
  ai_pipeline: AI_TRAINING_TEAM,
  member_stats: ACCOUNT_MANAGERS,
  navigator: { read: ALL, write: CONTENT_TEAM },
  treatments: { read: ALL, write: SUPERUSERS },
  wallets: [CANADA_TEAM, CLAIMS_TEAM, MX_TEAM],
};

// check whether a user is part of at least one of the given groups
const isPartOf = (user, groupOrGroups) => {
  // the second arg is the name of a group
  if (typeof groupOrGroups == 'string') {
    // every user is part of ALL
    if (groupOrGroups == ALL) return true;

    // the code should never reach here for superusers
    if (groupOrGroups == SUPERUSERS) return false;

    return user.groups.includes(groupOrGroups);
  }

  // the second arg is a list of group names
  for (const group of groupOrGroups) {
    if (isPartOf(user, group)) return true;
  }
  return false;
};

const isAccountManager = (user) => isPartOf(user, ACCOUNT_MANAGERS);

const isCrawOnly = (user) =>
  !user.isSuperuser &&
  user.groups.length === 1 &&
  user.groups[0] === CRAWFORD_TEAM;

const can = (user, action, module) => {
  if (user?.isSuperuser) return true;
  if (isCrawOnly(user) && module !== 'crawford') return false;
  if (!Object.hasOwn(PERMISSIONS, module)) return false;
  const perm = PERMISSIONS[module];
  if (typeof perm[action] !== 'undefined') {
    return isPartOf(user, perm[action]);
  } else {
    return isPartOf(user, perm);
  }
};

// check whether a user has read permissions for a module
const canRead = (user, module) => can(user, 'read', module);

// check whether a user has write permissions for a module
const canWrite = (user, module) => can(user, 'write', module);

export { canRead, canWrite, isAccountManager, isPartOf };
